// Per client's "INDUSTRIES WE SERVE" list — a plain tag/pill list
// rather than a card grid, since there's no per-industry content (no
// icon, description, or link) to justify a heavier layout; this reads
// as a breadth signal ("we work with all of these") without implying
// each one has a dedicated page.
const INDUSTRIES = [
  'Manufacturing', 'Retail', 'Wholesalers', 'Contractors', 'Transport', 'Medical', 'Education', 'Hospitality',
  'Restaurants', 'IT Companies', 'Freelancers', 'Professionals', 'Startups', 'MSME', 'Exporters', 'Importers',
  'Construction', 'E-Commerce Sellers',
];

export function IndustriesServed() {
  return (
    <section className="border-t border-line bg-white py-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="text-center">
          <p className="font-mono text-xs uppercase tracking-widest text-ledger-green">Who We Work With</p>
          <h2 className="mt-2 font-display text-3xl font-bold text-ink">Industries We Serve</h2>
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-3">
          {INDUSTRIES.map((industry) => (
            <span
              key={industry}
              className="rounded-full border border-line bg-paper px-4 py-2 text-sm font-medium text-ink/75"
            >
              {industry}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
